<template>
	<div id="ClientModalComponent">
		<button v-show="false" class="btn-link" data-toggle="modal" data-target="#clientModalComponent" ref="btnShowClientModalComponent" @click="showModalLocal">Nuevo Cliente</button>
		<div id="clientModalComponent" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="modalNewClient" aria-hidden="true" data-keyboard="false" data-backdrop="static">
			<div class="modal-dialog modal-lg">
				<div class="modal-content" v-if="!loading">
					<div class="modal-header">
						<h5 class="modal-title" v-if="(idLocal == 0)">Nuevo Cliente</h5>
						<h5 class="modal-title" v-else>{{objectClient.name}} {{objectClient.surname}} ({{idLocal}})</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="row">
							<div class="col-md-4">
								<div class="form-group">
									<label for="inputName">Nombre</label>
									<input type="text" class="form-control form-control-sm" v-model='objectClient.name' placeholder="Nombres">
								</div>
							</div>
							<div class="col-md-4">
								<div class="form-group">
									<label for="inputName">Apellido</label>
									<input type="text" class="form-control form-control-sm" v-model='objectClient.surname' placeholder="Apellidos">
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label for="inputName">Rut</label>
									<input type="text" class="form-control form-control-sm" v-model='objectClient.number_document' placeholder="12345678-9">
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-4">
								<div class="form-group">
									<label for="inputName">Fecha de nacimiento</label>
									<input type="date" class="form-control form-control-sm" v-model='objectClient.birthdate' placeholder="">
								</div>
							</div>
							<div class="col-md-5">
								<div class="form-group">
									<label for="inputName">Email</label>
									<input type="email" class="form-control form-control-sm" v-model='objectClient.email' placeholder="nombre@mail.com">
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label for="inputName">Telefono</label>
									<input type="text" class="form-control form-control-sm" v-model='objectClient.phone' placeholder="912345678">
								</div>
							</div>
						</div>
						<div class="row">
							<div class="form-group col-md-3">
								<label for="inputTypeClient">Tipo de Cliente</label>
								<select id="inputTypeClient" class="form-control form-control-sm" v-model="objectClient.type_client_id">
									<option v-for="(item, index) in listTypesClient" :key="index" :value="item.id">{{ item.name }}</option>
								</select>
							</div>
							<div class="form-group col-md-3">
								<label for="inputTypeColportor">Categoria Colportaje</label>
								<select id="inputTypeColportor" class="form-control form-control-sm" v-model="objectClient.type_colportor_id">
									<option v-for="(item, index) in listTypesColportor" :key="index" :value="item.id">{{ item.name }}</option>
								</select>
							</div>
						</div>
						<div v-if="objectClient.exists === 1">
							<hr>
							<ul class="nav nav-tabs" id="myTab" role="tablist">
								<li class="nav-objectClient">
									<a class="nav-link active" id="address-tab" data-toggle="tab" href="#address" role="tab" aria-controls="address-" aria-selected="false">Direcciones</a>
								</li>
								<li class="nav-objectClient">
									<a class="nav-link" id="price-list-tab" data-toggle="tab" href="#price-list" role="tab" aria-controls="price-list-" aria-selected="false">Lista de Precios</a>
								</li>
							</ul>
							<div class="tab-content" id="myTabContent">
								<div class="tab-pane fade show active margin-top5" id="address" role="tabpanel" aria-labelledby="address-tab">
									<table class="table table-sm table-12">
										<thead>
											<tr>
												<th class="text-center">#</th>
												<th class="text-center">Dirección</th>
												<th class="text-center">Comuna</th>
												<th class="text-center">Transporte</th>
												<th class="text-center">Envío</th>
												<th class="text-right"><i class="fas fa-plus-circle text-primary pointer" @click="addAddressLocal" v-show="!plusAddress"></i></th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(item, ind) in objectClient.address" :key="ind">
												<td class="text-center">{{item.id}}</td>
												<td>
													<input type="text"  style="width: 100%" v-model="item.street" :readonly="!(editingAddress == item.id)"/></td>
												</td>
												<td class="text-center">
													<select v-model="item.comuna_id" :disabled="!(editingAddress == item.id)">
														<option v-for="(it, ind) in listComunas" :key="ind" :value="it.id">{{ it.name }}</option>
													</select>
												</td>
												<td class="text-center">
													<select v-model="item.transport_id" :disabled="!(editingAddress == item.id)">
														<option v-for="(it, ind) in listTransports" :key="ind" :value="it.id">{{ it.name }}</option>
													</select>
												</td>
												<td class="text-center">
													<i class="far fa-check-circle text-primary" v-if="(item.send == 1)" title="Seleccionado"></i>
													<i class="far fa-circle text-secundary pointer" v-else title="Seleccionar" @click="selectClientAddressSendLocal(item.id)"></i>
												</td>
												<td class="text-right">
													<i class="far fa-save text-info pointer margin-right5" title="Guardar" @click="saveAddressLocal(item)" v-if="editingAddress == item.id"></i>
													<i class="far fa-edit text-warning pointer margin-right5" @click="editAddressLocal(item.id)" v-else></i>	 
													<i class="far fa-trash-alt text-danger pointer" @click="deleteAddressLocal(item.id)"></i>
												</td>
											</tr>
											<tr v-show="plusAddress">
												<td>{{objectAddress.id}}</td>
												<td><input type="text" style="width: 100%" v-model="objectAddress.street" ref="inputStreet"/></td>
												<td class="text-center">
													<select v-model="objectAddress.comuna_id">
														<option v-for="(item, index) in listComunas" :key="index" :value="item.id">{{ item.name }}</option>
													</select>
												</td>
												<td class="text-center">
													<select v-model="objectAddress.transport_id">
														<option v-for="(item, index) in listTransports" :key="index" :value="item.id">{{ item.name }}</option>
													</select>
												</td>
												<td>
												</td>
												<td class="text-right">
													<i class="far fa-save text-info pointer margin-right5" title="Guardar" @click="saveAddressLocal(objectAddress)"></i>
													<i class="fas fa-minus-circle pointer text-danger" @click="plusAddress = !plusAddress"></i>
												</td>
											</tr>

										</tbody>
									</table>
								</div>
								<div class="tab-pane fade show margin-top5" id="price-list" role="tabpanel" aria-labelledby="price-list-tab">
									<table class="table table-sm table-12">
										<thead>
											<tr>
												<th class="text-center">#</th>
												<th class="text-center">ID</th>
												<th class="text-center">Lista de Precio</th>
												<th class="text-right"><i class="fas fa-plus-circle text-primary pointer" @click="addClientPriceListLocal"></i></th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(item, index) in objectClient.client_price_list" :key="index">
												<td class="text-center">{{ index + 1 }}</td>
												<td class="text-center">{{ item.price_list_id }}</td>
												<td class="text-center">
													<span v-if="item.exists == 1">{{ item.price_list }}</span>
													<select v-else v-model="item.price_list_id">
														<option v-for="(it, ind) in listPriceListsComponent" :key="ind" :value="it.id">{{ it.name }}</option>
													</select>
												</td>
												<td class="text-right"><i class="fas fa-minus-circle text-danger pointer" @click="deleteClientPriceListLocal(it)"></i></td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" @click="saveClientLocal" :disabled="disabledBtnSave">Guardar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" ref="closeModalNewClient">Cerrar</button>
					</div>
				</div>
				<div v-else>
					Cargando . . .
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import errors from '@/mixins/errors.js'
	import axiosAction from '@/mixins/axiosAction.js'
	import clients from '@/mixins/clients'
	import typeClient from '@/mixins/clients/typeClient.js'
	import priceList from '@/mixins/generals/priceList.js'
	import comuna from '@/mixins/generals/comuna.js'
	import transports from '@/mixins/transports'
	import address from '@/mixins/generals/address.js'
	import typeColportor from '@/mixins/teams/typeColportor.js'

	export default {
		mixins: [mixin, errors, axiosAction, clients, typeClient, priceList, comuna, transports, address, typeColportor],
		props: ['id'],
		name: 'ClientModalComponent',
		data () {
			return {
				editingAddress: 0,
				plusAddress: false,
				loading: false
			}
		},
		computed: {
			disabledBtnSave() {
				if(this.objectClient.name.trim().length > 2 && this.objectClient.surname.trim().length > 2)
					return false
				return true
			},
			idLocal() {
				this.clearObjectClient()
				if(this.id != 0) {
					this.showClientLocal(this.id)
				}
				return this.id
			},
			listPriceListsComponent() {
				return this.listPriceLists
			}
		},
		methods: {
			addAddressLocal() {
				this.editingAddress = 0
				this.plusAddress = true
				this.clearObjectAddress()
				setTimeout(() => {
					this.$refs.inputStreet.focus()
				}, 300);
			},
			addClientPriceListLocal() {
				this.objectClient.client_price_list.push({
					exists: 0,
					client_id: this.objectClient.id,
					price_list_id: 0,
					price_list: 'Nuevo'
				})
			},
			deleteAddressLocal(id) {
				this.deleteAddress(id)
			},
			deleteAddressResultLocal(response) {
				if(response.data.success == true) {
					let index = this.objectClient.address.map((el) => parseInt(el.id)).indexOf(parseInt(response.data.data))
					if(index > -1)
						return this.objectClient.address.splice(index, 1)
					return false
				}
			},
			deleteClientPriceListLocal(item) {
				this.editingAddress = 0
				this.plusAddress = false
				this.$emit('deleteClientPriceList', item)
			},
			editAddressLocal(id) {
				this.editingAddress = id
				this.plusAddress = false
			},
			getAllComunasResultLocal(response) {},
			getAllPriceListsResultLocal(response) {},
			getAllTypesClientResultLocal(response) {},
			getAllTypesColportorResultLocal(response) { console.log(response)},
			resultAxiosLocal(responseLocal, response) {
				this.$emit('hideLockScreen')
				switch(responseLocal) {
					case 'deleteAddressResult': this.deleteAddressResult(response); break;
					case 'getAllComunasResult': this.getAllComunasResult(response); break;
					case 'getAllPriceListsResult': this.getAllPriceListsResult(response); break;
					case 'getAllTypesColportorResult': this.getAllTypesColportorResult(response); break;
					case 'getAllTypesClientResult': this.getAllTypesClientResult(response); break;
					case 'getAllTransportsResult': this.getAllTransportsResult(response); break;
					case 'saveAddressResult': this.saveAddressResult(response); break;
					case 'saveClientPOSTResult': this.saveClientResult(response, responseLocal); break;
					case 'saveClientPUTResult': this.saveClientResult(response, responseLocal); break;
					case 'setClientAddressSendResult': this.setClientAddressSendResult(response); break;
					case 'showClientResult': this.showClientResult(response); break;
					default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
				}
			},
			selectClientAddressSendLocal(id) {
				this.plusAddress = false
				this.editingAddress = 0
				this.setClientAddressSend(this.objectClient.id, id)
			},
			saveAddressLocal(item){
				let controller = (item.exists == 0) ? 'client/' + this.objectClient.id + '/' : ''
				this.saveAddress(item, controller)
			},
			saveAddressResultLocal(response) {
				if(response.data.success == true) {
					if(response.data.message == 'NUEVO') {
						this.objectClient.address.push(response.data.data)
						if(confirm('¿Desea que esta dirección sea la predeterminada para los próximos envíos?')) {
							this.selectClientAddressSendLocal(response.data.data.id)
						}
					} else if(response.data.message == 'ACTUALIZADO') {
						this.editingAddress = 0
					}
					this.plusAddress = false
					this.clearObjectAddress()
				}
			},
			saveClientLocal() {
				this.saveClient(this.objectClient)
			},
			saveClientResultLocal(response) {
				if(response.data.success == true) {
					this.$emit('actionSaveClient', response.data)
				}
			},
			setClientAddressSendResultLocal(response) {
				if(response.data.success == true) {
					for(let i = 0; i < this.objectClient.address.length; i++) {
						this.objectClient.address[i].send = (this.objectClient.address[i].id == response.data.data.id) ? 1 : 0
					}
				}
			},
			showClientLocal(id) {
				this.loading = true
				this.clearObjectClient()
				this.showClient(id)
			},
			showClientResultLocal(response) {
				this.loading = false
			},
			showModalLocal() {
				this.editingAddress = 0
				this.plusAddress = false
				if(this.listTypesClient.length == 0 || this.listPriceLists.length == 0) {
					this.getDependencies()
				}
			},
			getDependencies() {
				this.getAllPriceLists()
				this.getAllTypesClient()
				this.getAllTypesColportor()
				this.getAllComunas()
				this.getAllTransports()
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
